import { Box, TableCell, TableRow, useTheme } from '@material-ui/core';
import { formatDateTimeReadable, PaymentAttempt } from '@nemuru-eng/js-api-client';
import { PaymentAttemptStatus } from '@nemuru-eng/js-api-client/slim';
import React from 'react';

import { usePaymentAttemptsTable } from '@/components/modules/PaymentAttempts/shared/hooks/usePaymentAttemptsTable';
import { PaymentAttemptIcon } from '@/components/modules/PaymentAttempts/shared/maps/paymentAttemptIcon';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

export const PaymentAttemptsTableBody: React.FC<{ paymentAttempts: PaymentAttempt[] }> = ({ paymentAttempts }) => {
  const { classes, columns } = usePaymentAttemptsTable();
  const { palette } = useTheme();
  const { isMobile } = useScreen();

  return (
    <>
      {paymentAttempts
        .sort((a, b) => (a.createdAt.getTime() > b.createdAt.getTime() ? 1 : -1))
        .map((paymentAttempt) => {
          const color =
            paymentAttempt.status === PaymentAttemptStatus.PAYMENT_SUCCESSFUL
              ? palette.success.main
              : paymentAttempt.status === PaymentAttemptStatus.PAYMENT_FAILED
              ? palette.error.main
              : palette.text.secondary;
          return (
            <TableRow key={paymentAttempt.id} className={classes.root}>
              <TableCell align={'left'}>
                {!isMobile ? (
                  <Box display={'flex'} alignItems={'center'}>
                    <i className={'material-icons-outlined'} style={{ color, fontSize: 16, marginRight: 10 }}>
                      {PaymentAttemptIcon[paymentAttempt.status]}
                    </i>
                    <Font variant={'body2'} color={'textPrimary'}>
                      <Text tId={paymentAttempt.status} />
                    </Font>
                  </Box>
                ) : (
                  <Font variant={'body2'} color={'textPrimary'}>
                    <Text tId={paymentAttempt.status} />
                  </Font>
                )}
              </TableCell>
              {columns.some((column) => column.name === 'failReason') && (
                <TableCell align={'left'}>
                  {paymentAttempt.failReason && (
                    <Font variant={'body2'} color={'textPrimary'}>
                      <Text tId={`PAYMENT_ATTEMPT_FAIL_REASON_${paymentAttempt.failReason}`} />
                    </Font>
                  )}
                </TableCell>
              )}
              <TableCell align={'right'}>
                <Font variant={'body2'} color={'textPrimary'}>
                  {formatDateTimeReadable(paymentAttempt.createdAt)}
                </Font>
              </TableCell>
            </TableRow>
          );
        })}
    </>
  );
};
